import { units } from '../../../../units';

export const schema = {
  type: 'object',
  properties: {
    label: {
      type: 'string',
      title: 'Label',
    },
    defaultEmptyValue: {
      type: 'string',
      title: 'Default text (when no value)',
    },
    unit: {
      type: 'string',
      title: 'Unit',
      default: units[0].id,
      oneOf: units.map((unit) => ({
        enum: [unit.id],
        title: `${unit.category}: ${unit.name}`,
      })),
      description: 'Automatic unit conversion (e.g., kW to MW) is applied to default signal units',
    },
    unitLabel: {
      type: 'string',
      title: 'Custom unit label',
      description: 'This takes precedence over Unit',
    },
    decimals: {
      default: 'auto',
      title: 'Decimals',
      type: 'string',
      enum: ['auto', '0', '1', '2', '3', '4', '5'],
    },
  },
};

export const uiSchema = {
  unit: {
    'ui:field': 'customUnitLabel',
  },
  unitLabel: {
    'ui:field': 'customUnitLabel',
  },
};
